import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: '',
};

export const userSlice = createSlice({
  name: "User",
  initialState,
  reducers: {
    User: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { User } = userSlice.actions;

export default userSlice.reducer;
